import React from 'react';

/** This is the little "WAITING" blip for waiting on an Online player to submit something */
export default function (props) {

  if (!props.isActive) { return null}

  const style = {
    position:"absolute",
    left: "50%",
    top: "-0.5em",
    width: "4em",
    marginLeft: "-2em",
    textAlign: "center",
    padding: "0.3em 0",
    fontSize: "0.4em",
    background: "#042129",
    color: "#fff"
  };

  return (
    <div style={style}>...</div>
  )
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaCombatantWaitingBlip.js